import { render, staticRenderFns } from "./myAuditLog.vue?vue&type=template&id=255965da&scoped=true"
import script from "./myAuditLog.vue?vue&type=script&lang=ts"
export * from "./myAuditLog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255965da",
  null
  
)

export default component.exports